import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';

function paramDeger(ek: any, ismi: string): any {
  const diziden = ek?.parametreler?.find((p: any) => p.ismi === ismi)?.degeri;
  if (diziden != null) return diziden;
  return ek?.[ismi] ?? '';
}

@Component({
  selector: 'kalite-olcum-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ko-edit">
      <div class="ko-baslik">
        <div class="ko-baslik-ikon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 12h6l3-9 3 18 3-9h5"/></svg>
        </div>
        <span>Kalite Ölçümü</span>
      </div>

      <div class="ko-form">
        <div class="form-grup">
          <label>Ölçüm Noktası <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('olcumNoktasi')" (ngModelChange)="guncelle('olcumNoktasi', $event)" placeholder="ör: Çap A, Uzunluk B..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-satir">
          <div class="form-grup">
            <label>Ölçülen Değer <span class="zorunlu">*</span></label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('olculenDeger') || 0" (ngModelChange)="guncelle('olculenDeger', $event)" [nzStep]="0.001" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Sonuç</label>
            <div class="input-wrap">
              <nz-select [ngModel]="deger('sonuc') || 'Uygun'" (ngModelChange)="guncelle('sonuc', $event)" style="width:100%">
                <nz-option nzValue="Uygun" nzLabel="Uygun" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#22c55e"></span>Uygun</span></nz-option>
                <nz-option nzValue="Uygun Değil" nzLabel="Uygun Değil" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#ef4444"></span>Uygun Değil</span></nz-option>
                <nz-option nzValue="Şartlı" nzLabel="Şartlı" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#f59e0b"></span>Şartlı</span></nz-option>
              </nz-select>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="form-satir">
          <div class="form-grup">
            <label>Tolerans Alt</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('toleransAlt') || 0" (ngModelChange)="guncelle('toleransAlt', $event)" [nzStep]="0.001" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Tolerans Üst</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('toleransUst') || 0" (ngModelChange)="guncelle('toleransUst', $event)" [nzStep]="0.001" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

    :host { display: block; }
    .ko-edit { display: flex; flex-direction: column; padding: 0; }
    .ko-baslik { display: flex; align-items: center; gap: 10px; padding: 12px 16px; margin-bottom: 4px; border-radius: 10px; background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent); }
    .ko-baslik-ikon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #059669, #34d399); color: #fff; flex-shrink: 0; box-shadow: 0 2px 8px rgba(5,150,105,0.35); }
    .ko-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }
    .ko-form { display: flex; flex-direction: column; gap: 14px; padding: 4px 2px; }
    .form-satir { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
    .form-grup { display: flex; flex-direction: column; gap: 5px; }
    .form-grup label { font-size: 11px; font-weight: 500; color: var(--py-metin-ucuncul, rgba(0,0,0,0.45)); text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px; transition: color 0.2s; }
    .form-grup:focus-within label { color: var(--py-link, #1890ff); }
    .zorunlu { color: #ff4d4f; font-size: 13px; line-height: 1; vertical-align: middle; }
    .input-wrap { position: relative; }
    .input-glow { position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px; background: linear-gradient(90deg, #059669, #34d399, #059669); transition: width 0.35s cubic-bezier(0.4,0,0.2,1), left 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.3s; opacity: 0; pointer-events: none; z-index: 1; }
    .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }
    .input-wrap input[nz-input] { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)); border: 1px solid var(--py-kenarlik, #d9d9d9); border-radius: 8px; padding: 7px 11px; font-size: 13px; color: var(--py-metin, #333); transition: border-color 0.25s, background 0.25s, box-shadow 0.25s; }
    .input-wrap input[nz-input]:focus { border-color: var(--py-kenarlik-aktif, #1890ff); background: var(--py-input-arka, #fff); box-shadow: 0 0 0 2px rgba(5,150,105,0.1); outline: none; }
    .input-wrap ::ng-deep .ant-select-selector { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important; border: 1px solid var(--py-kenarlik, #d9d9d9) !important; border-radius: 8px !important; min-height: 34px; }
    .input-wrap ::ng-deep .ant-input-number { width: 100% !important; border-radius: 8px; }
    .ac-opt { display: flex; align-items: center; gap: 8px; }
    .ac-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
  `],
})
export class KaliteOlcumEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek[alan] = deger;
    this.parametreler.set({ ...params });
  }
}
